function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocShopRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.009 16.189a5.987 5.987 0 01-6.01.005 5.985 5.985 0 01-6.008-.005A5.948 5.948 0 017 17c-.342 0-.674-.035-1-.09V26a2 2 0 002 2h3.5v-4.5c0-2.482 2.019-4.5 4.5-4.5 2.482 0 4.5 2.018 4.5 4.5V28H24a2 2 0 002-2v-9.09a5.988 5.988 0 01-1 .09 5.951 5.951 0 01-2.991-.811z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 21a2.5 2.5 0 00-2.5 2.5V28h5v-4.5A2.5 2.5 0 0016 21zM16 13.643a3.99 3.99 0 003 1.356 3.99 3.99 0 003-1.357c.007.008.024.011.032.019A3.976 3.976 0 0025 14.998a4 4 0 004-4l-3.307-8H6.307L3 11a4 4 0 004 4 3.972 3.972 0 002.967-1.338c.009-.008.026-.011.033-.018a3.99 3.99 0 003 1.356 3.99 3.99 0 003-1.357z",
    fill: props.color
  }));
}

export default SvgIconPocShopRexFilled;